<template>
    <div class="main">
        <div class="mainTop">
            <div class="mainAddress" @click="selsecCity">
                {{cityName}}<van-icon name="arrow" />
            </div>
            <van-picker
            v-show="cityListFlag"
            show-toolbar
            title="选择城市"
            :columns="cityList"
            value-key="provinceName"
            @cancel="onCancel"
            @confirm="onConfirm"
            />
        </div>
        <div class="mainContent">
            <van-search
            v-model="value"
            placeholder="请输入医院关键词"
            show-action
            @search="onSearch"
            background="#ffffff"
            >
            <div slot="action" @click="onSearch">搜索</div>
            </van-search>
        </div>
        <div class="mainSearchContent" :style="{'height':height}">
            <ul>
                <li v-for="item in hospitalList" :key="item.id" @click="goToApplyFirst(item)">
                    <div class="hospitalLogoDiv">
                        <span class="hospitalLogo" :style="{backgroundImage:'url('+item.orgLogo+')','background-repeat': 'no-repeat','background-size': '70%','background-position':'center'}"></span>
                    </div>
                    <div class="hospitalContent">
                        <div class="hospitalTags">
                            <span class="hospitalTag" v-for="it in item.caseList" :key="it.serviceId" v-if="it.serviceId=='4'">住院病案</span>
                            <!-- <span class="hospitalTag" v-for="it in item.caseList" :key="it.serviceId" v-if="it.serviceId=='5'">急诊病案</span>
                            <span class="hospitalTag" v-for="it in item.caseList" :key="it.serviceId" v-if="it.serviceId=='6'">门诊病案</span> -->
                            <span class="hospitalYYZT" v-for="it in item.serviceList" :key="it.serviceId" v-if="it.serviceId=='1'">预约自提</span>
                            <span class="hospitalYJZT" v-for="it in item.serviceList" :key="it.serviceId" v-if="it.serviceId=='2'">邮寄</span>
                            <span class="hospitalYJZT" v-for="it in item.serviceList" :key="it.serviceId" v-if="it.serviceId=='3'">自提</span>
                        </div>
                        <div class="hospitalName">{{item.orgName}}</div>
                    </div>
                    <van-icon name="arrow"/>
                </li>
            </ul>
        </div>
    <div class="caseApplyBg" v-show="cityListFlag" @click="closeCityList"></div>
    <!-- <div class="caseApplyBg" v-show="loadingFlag"></div>
    <van-loading color="white" v-show="loadingFlag"/> -->
    </div>
</template>
<script>
  import ApiSetting from '@/assets/js/api'
  export default {
    name: 'home',
    data () {
      return {
        value: '',
        hospitalList:[],
        height:'',
        cityName:'北京市',
        regionCode:'110000',
        regionType:'26',
        param:{
            provinceCode:'110000',
            regionType:'26'//26省|27市|28区县
        },
        cityListFlag:false,
        cityList: [],
        // loadingFlag:false
      }
    },
    created(){
       this.height=document.documentElement.clientHeight - 90 +'px'
    },
    mounted(){
      let code = this.$utils.getUrlKey("code");
      if (code !=undefined) {
        this.$http.get(ApiSetting.getOpenId + code).then((response) => {
        })
      }
      this.getCityAllHospital();
      //this.onSearch();
      this.addressFun();
    },
    methods: {
        //搜索地区机构
        onSearch () {
            var param={
                name:this.value
            }
            this.postRequest(ApiSetting.searchOnlineOrgList,param).then((res) => {
                if(res.data.responseCode=='200'){
                    this.hospitalList=res.data.data
                }
            })
        },
        //获取地区机构列表
        getCityAllHospital(param){
            // this.loadingFlag=true
            var param={
                regionCode:this.regionCode,
                regionType:this.regionType
            }
          this.postRequest(ApiSetting.getOnlineOrgListByRegion, param).then((res) => {
                  if(res.data.responseCode=='200'){
                    this.hospitalList=res.data.data
                    // this.loadingFlag=false
                  }
              })
        },
        onConfirm(value) {
            this.cityName=value.provinceName
            this.regionCode=value.provinceCode,
            this.getCityAllHospital(this.param)
            this.cityListFlag=false
        },
        onCancel() {
            this.cityListFlag=false
        },
        selsecCity(){
            this.addressFun()
            this.cityListFlag=true
        },
        closeCityList(){
            this.cityListFlag=false
        },
        addressFun(){
            this.postRequest(ApiSetting.getoOnlineByRegion).then((res) => {
                if(res.data.responseCode=='200'){
                    this.cityList=res.data.data
                }
            })
        },
        goToApplyFirst (obj) {
            sessionStorage.setItem('obj',JSON.stringify(obj))
            if(obj.copyFlag=='1'){
                this.$router.push({path: '/caseApplyFirst1'})
            }else{
                this.$router.push({path: '/caseApplyFirst'})
            }
      }
    }
  }
</script>
<style lang="less">
.van-picker{
    clear: both;
    position: fixed !important;
    bottom: 0;
    width: 100%;
    z-index: 99;
}
.van-loading{
    width: 1rem !important;
    height: 1rem !important;
    position: fixed !important;
    left: 50%;
    top: 50%;
    margin-left: -0.5rem;
    margin-top: -0.5rem;
    z-index: 99 !important;
}
    .main {
        font-size: 0.28rem;
        background: #f2f2f2;
        overflow: hidden;
        .van-cell{
            background: #f2f2f2;
            border-radius: 0.1rem 0 0 0.1rem !important;
        }
        .van-search--show-action{
            padding-right: 0.4rem;
        }
        .van-search__action{
            background: #1C84F2;
            color: #fff;
            border-radius: 0 0.1rem 0.1rem 0;
        }
        .mainTop {
            height: 1rem;
            line-height: 1rem;
            border-bottom: 1px solid #e4e4e4;
            background:#ffffff;
            .mainAddress {
                color: #1C84F2;
                height: 0.48rem;
                line-height: 0.48rem;
                border: 1px solid #1C84F2;
                width: auto;
                text-align: center;
                border-radius: 0.24rem;
                float: left;
                margin-top: 0.26rem;
                margin-left: 0.26rem;
                padding-left: 0.2rem;
                .van-icon{
                    float: right;
                    margin-top: 0.08rem;
                    margin-right: 0.2rem;
                }
            }

        }
        .mainContent {
            border-bottom: 1px solid #e4e4e4;

        }
        .mainSearchContent {
            overflow: auto;
            li {
                height: 1.6rem;
                width: 100%;
                background: #ffffff;
                margin-top: 0.2rem;
                position: relative;
                .hospitalLogoDiv {
                    height: 1.6rem;
                    float: left;
                    margin-left: 0.26rem;
                    .hospitalLogo {
                        width: 1rem;
                        height: 1rem;
                        margin-top: 0.36rem;
                        // border-radius: 50%;
                        display: inline-block;
                        //background: #b4ebf1;
                    }
                }
                .hospitalContent {
                    float: left;
                    margin-left: 0.1rem;
                    .hospitalTags {
                        height: 0.8rem;
                        width: 100%;
                        font-size: 0.24rem;
                        .hospitalTag {
                            color: #1C84F2;
                            height: 0.4rem;
                            line-height: 0.4rem;
                            border: 1px solid #1C84F2;
                            width: 1.2rem;
                            text-align: center;
                            border-radius: 0.2rem;
                            float: left;
                            margin-top: 0.2rem;
                            margin-left: 0.1rem;
                            padding: 0.02rem 0.1rem;
                        }
                        .hospitalYYZT {
                            height: 0.4rem;
                            line-height: 0.4rem;
                            background: #cccc33;
                            width: 1.2rem;
                            text-align: center;
                            border-radius: 0.2rem;
                            float: left;
                            margin-top: 0.21rem;
                            margin-left: 0.2rem;
                            color: #ffffff;
                            padding: 0.02rem 0.1rem;
                        }
                        .hospitalYJZT {
                            height: 0.4rem;
                            line-height: 0.4rem;
                            background: #1C84F2;
                            width: 0.8rem;
                            text-align: center;
                            border-radius: 0.2rem;
                            float: left;
                            margin-top: 0.21rem;
                            margin-left: 0.1rem;
                            color: #ffffff;
                            padding: 0.02rem 0.1rem;
                        }
                    }
                }
                .hospitalName {
                    margin-left: 0.1rem;
                    font-size: 0.32rem;
                    height: 0.8rem;
                    line-height: 0.8rem;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                    width: 5.8rem;
                }
                .van-icon {
                    height: 0.28rem;
                    position: absolute;
                    top: 0.76rem;
                    right: 0.2rem;
                }
            }
        }
    }

</style>

